var _defs, _path, _path2, _rect, _path3, _path4, _path5, _rect2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect3, _path22, _path23, _rect4, _g, _path24, _rect5, _path25, _path26, _path27, _path28, _rect6, _path29, _rect7, _rect8, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _rect9, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g2, _path68, _rect10, _path69, _rect11, _g3, _g4, _g5, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _rect12, _rect13, _path81, _path82, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path83, _path84, _rect20, _rect21, _path85, _path86, _rect22, _rect23, _path87, _path88, _rect24, _rect25, _path89, _path90, _rect26, _rect27, _path91, _path92, _rect28, _rect29, _path93, _path94, _path95, _rect30, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _rect31, _rect32, _path106, _g6, _g7, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _g8, _g9, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _g10, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_105",
    "data-name": "Grupo 105",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 578.977,
    height: 548.559,
    viewBox: "0 0 578.977 548.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_123",
    "data-name": "Ret\\xE2ngulo 123",
    width: 578.977,
    height: 548.559,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_81",
    "data-name": "Ret\\xE2ngulo 81",
    width: 345.648,
    height: 36.026,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_87",
    "data-name": "Ret\\xE2ngulo 87",
    width: 32.702,
    height: 5.402,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_91",
    "data-name": "Ret\\xE2ngulo 91",
    width: 38.113,
    height: 7.436,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_95",
    "data-name": "Ret\\xE2ngulo 95",
    width: 38.113,
    height: 8.223,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_117",
    "data-name": "Ret\\xE2ngulo 117",
    width: 3.724,
    height: 3.683,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_118",
    "data-name": "Ret\\xE2ngulo 118",
    width: 46.723,
    height: 12.491,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_119",
    "data-name": "Ret\\xE2ngulo 119",
    width: 3.726,
    height: 3.682,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_120",
    "data-name": "Ret\\xE2ngulo 120",
    width: 46.61,
    height: 13.098,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_121",
    "data-name": "Ret\\xE2ngulo 121",
    width: 53.966,
    height: 92.014,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_104",
    "data-name": "Grupo 104",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_103",
    "data-name": "Grupo 103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_102",
    "data-name": "Grupo 102",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M167.313,421.308c-1.785-1.53-5.765-6.378-2.7-12.018,1.125-2.066,3.516-3.089,5.678-4s4.438-1.7,6.227-3.225c3.376-2.872,4.307-7.643,6.547-11.475,2.573-4.4,7.375-7.693,12.448-7.463,5.809.265,10.653,5.01,12.85,10.419s2.273,11.418,2.319,17.26c.024,3.23-.119,6.873-2.49,9.054-2.187,2.011-5.48,2.036-8.442,1.945l-31.749-.976",
    transform: "translate(45.827 107.389)",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M232.183,344.757H148.69l15.04,89.68a10.015,10.015,0,0,0,7.129,7.984c.1.031.2.052.292.079.25.064.489.148.744.192a10.437,10.437,0,0,0,1.7.2c.005.027.009.058.014.086l.407-.065h37.213a10.44,10.44,0,0,0,2.045-.2,10.052,10.052,0,0,0,8.447-8.765l7.249-61.79.328-2.457h-.038l2.87-24.47Zm-15.75,57.205h-8.569l.864-26.027h9.928Zm3.055-26.027h8.2l-3.054,26.027h-7.373Zm-24.478,54.879-.521-22.61h12.338l-.75,22.61ZM181.669,408.2h11.989l.521,22.61H183.426Zm.926,22.61H172.543c-.955-6.1-2.2-14.039-3.544-22.61h11.839Zm-1.411-28.852-2.023-26.027h13.754l.6,26.027Zm13.159,0-.6-26.027H207.9l-.864,26.027Zm-.743-32.269-.556-24.1h15.862l-.8,24.1Zm-.83,0H178.676l-1.873-24.1h15.414Zm-14.926,0H162.932c-.527-3.329-1.029-6.481-1.481-9.315-1.556-9.744-2.141-13.409-2.465-14.788h16.986Zm.485,6.241,2.023,26.027H168.02c-.415-2.641-.835-5.312-1.256-7.987-.967-6.143-1.935-12.286-2.844-18.041Zm-11.149,26.027h-8.057l-4.366-26.027h8.322c1.271,8.044,2.681,17,4.1,26.027m.979,6.241c1.229,7.824,2.438,15.539,3.544,22.61h-7.742L160.17,408.2Zm38.745,22.61.75-22.61H215.9l-1.932,22.61Zm2.029-61.12.8-24.1h11.511l-2.059,24.1ZM158.2,345.59c.33,1.743,1.855,11.227,3.9,24.1h-8.381l-4.042-24.1Zm63.055,85.224H214.8l1.932-22.61H223.9Zm7.171-61.12h-8.4l2.059-24.1h9.171Z",
    transform: "translate(41.679 96.637)",
    fill: "#e0e0e0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_76",
    "data-name": "Ret\\xE2ngulo 76",
    width: 129.65,
    height: 87.389,
    transform: "matrix(0.986, -0.167, 0.167, 0.986, 361.894, 59.123)",
    fill: "#ebebeb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M410.49,29.262a9.123,9.123,0,0,1-1,1.348l-3.03,3.722L395.142,47.889,357.363,92.443l-.311.366-.423-.234-1.019-.565-51.7-28.843-15.6-8.857-4.214-2.461a9.237,9.237,0,0,1-1.43-.928,9.172,9.172,0,0,1,1.545.721l4.32,2.267,15.784,8.531c13.372,7.357,31.661,17.42,51.869,28.541l1.02.565-.732.133,38.046-44.325,11.6-13.316q1.992-2.23,3.2-3.578a9.121,9.121,0,0,1,1.175-1.2",
    transform: "translate(79.231 8.202)",
    fill: "#fafafa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M294.067,126.488c-.28-.165,7.331-13.6,17-30.014S328.8,66.89,329.079,67.055s-7.33,13.6-17,30.017-17.732,29.581-18.013,29.416",
    transform: "translate(82.426 18.796)",
    fill: "#fafafa"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M354.458,60.591c.219-.241,11.7,9.875,25.65,22.59s25.077,23.221,24.858,23.462-11.7-9.872-25.652-22.592-25.075-23.218-24.856-23.459",
    transform: "translate(99.355 16.983)",
    fill: "#fafafa"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_77",
    "data-name": "Ret\\xE2ngulo 77",
    width: 65.125,
    height: 43.897,
    transform: "translate(35.715 273.916) rotate(-5.077)",
    fill: "#f5f5f5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M92.765,209.445a4.579,4.579,0,0,1-.552.635l-1.666,1.744c-1.511,1.542-3.619,3.695-6.208,6.339L63.65,238.969l-.17.172-.2-.134-.488-.323-24.743-16.5-7.46-5.056-2.011-1.4a4.662,4.662,0,0,1-.679-.521,4.776,4.776,0,0,1,.745.423l2.073,1.307,7.564,4.9,24.838,16.355.488.323-.371.038c8.122-8.072,15.456-15.359,20.813-20.683,2.645-2.587,4.8-4.7,6.341-6.206.723-.693,1.3-1.246,1.742-1.666a4.616,4.616,0,0,1,.636-.552",
    transform: "translate(7.819 58.708)",
    fill: "#e0e0e0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    d: "M30.931,254.308c-.133-.093,4.212-6.519,9.7-14.353s10.057-14.108,10.191-14.014-4.212,6.521-9.707,14.353S31.064,254.4,30.931,254.308",
    transform: "translate(8.669 63.332)",
    fill: "#e0e0e0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30",
    "data-name": "Caminho 30",
    d: "M63.273,224.017c.119-.111,5.468,5.411,11.945,12.332s11.634,12.624,11.515,12.736-5.467-5.409-11.947-12.333-11.633-12.624-11.514-12.735",
    transform: "translate(17.735 62.793)",
    fill: "#e0e0e0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_31",
    "data-name": "Caminho 31",
    d: "M455.475,187.313s.044-.346.148-.985q.167-.993.475-2.815c.43-2.481,1.054-6.084,1.85-10.685,1.62-9.217,3.941-22.425,6.766-38.495l.209.3-77.071-13.759h-.006l.373-.259c-3.4,18.895-6.628,36.846-9.522,52.928l-.237-.341,55.465,10.1,15.853,2.923c1.826.344,3.239.609,4.222.794l1.093.214a3.652,3.652,0,0,1,.38.086,2.644,2.644,0,0,1-.352-.046l-1.068-.173-4.178-.714c-3.694-.643-9.05-1.577-15.814-2.757l-55.706-9.843-.289-.051.053-.291c2.877-16.084,6.087-34.039,9.467-52.938l.056-.316.318.056h.005l77.049,13.882.255.046-.046.255c-2.947,16.115-5.371,29.361-7.061,38.605-.849,4.566-1.512,8.141-1.969,10.6q-.34,1.786-.525,2.759c-.12.618-.193.921-.193.921",
    transform: "translate(105.974 33.688)",
    fill: "#e0e0e0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32",
    "data-name": "Caminho 32",
    d: "M462.817,134.3a6.872,6.872,0,0,1-.877.636l-2.585,1.718-9.569,6.218-31.7,20.311c-.863-.152-.246-.052-.442-.091l-.014-.017-.026-.035-.051-.069-.1-.137-.207-.274-.415-.547-.825-1.09-1.632-2.156-3.191-4.217c-2.087-2.765-4.1-5.434-6.023-7.978l-10.168-13.53-6.81-9.157q-1.15-1.579-1.826-2.508a6.724,6.724,0,0,1-.6-.9,6.944,6.944,0,0,1,.7.823q.713.9,1.922,2.435l6.974,9.033c2.937,3.843,6.418,8.4,10.278,13.448l6.053,7.955q1.571,2.072,3.2,4.211.812,1.07,1.635,2.155l.825,1.09.415.547.209.274.1.137.051.069.027.033.013.018c-.187-.031.437.091-.416-.064l31.8-20.152,9.678-6.046,2.649-1.617a6.9,6.9,0,0,1,.947-.526",
    transform: "translate(108.128 33.77)",
    fill: "#e0e0e0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_33",
    "data-name": "Caminho 33",
    d: "M409.282,142.55c.111.138-6.755,5.818-15.332,12.684s-15.625,12.322-15.736,12.183,6.754-5.816,15.334-12.685,15.622-12.32,15.734-12.182",
    transform: "translate(106.015 39.957)",
    fill: "#e0e0e0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_34",
    "data-name": "Caminho 34",
    d: "M443.073,180.936c-.156.086-4.621-7.791-9.972-17.588s-9.564-17.813-9.408-17.9,4.619,7.789,9.972,17.59,9.564,17.812,9.408,17.9",
    transform: "translate(118.762 40.77)",
    fill: "#e0e0e0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_35",
    "data-name": "Caminho 35",
    d: "M187.007,250.524V265.4H123.028a7.439,7.439,0,1,1,0-14.878",
    transform: "translate(32.4 70.223)",
    fill: "#e0e0e0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_36",
    "data-name": "Caminho 36",
    d: "M176.929,261.6h-21.2a4.193,4.193,0,0,1-4.193-4.193v-.255a4.193,4.193,0,0,1,4.193-4.193h21.2Z",
    transform: "translate(42.478 70.906)",
    fill: "#fafafa"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37",
    "data-name": "Caminho 37",
    d: "M187.007,238.9v14.88H123.028a7.44,7.44,0,1,1,0-14.88Z",
    transform: "translate(32.4 66.965)",
    fill: "#f5f5f5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38",
    "data-name": "Caminho 38",
    d: "M176.929,249.98h-21.2a4.193,4.193,0,0,1-4.193-4.193v-.255a4.193,4.193,0,0,1,4.193-4.193h21.2Z",
    transform: "translate(42.478 67.649)",
    fill: "#e0e0e0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_39",
    "data-name": "Caminho 39",
    d: "M137.506,220.261l-10.161,23.866h6.54l4.514-12.747Z",
    transform: "translate(35.695 61.74)",
    fill: "#e0e0e0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_40",
    "data-name": "Caminho 40",
    d: "M166.861,203.392l3.925,45.464H137.576l-3.648-45.464Z",
    transform: "translate(37.541 57.012)",
    fill: "#ebebeb"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41",
    "data-name": "Caminho 41",
    d: "M162.56,206.257,166,244.338l-24.929.328L137.7,206.036Z",
    transform: "translate(38.598 57.753)",
    fill: "#fafafa"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_42",
    "data-name": "Caminho 42",
    d: "M155.983,210.326l1.956,26.2h-13.3l-2.346-26.2Z",
    transform: "translate(39.886 58.956)",
    fill: "#e0e0e0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43",
    "data-name": "Caminho 43",
    d: "M578.977,421.544c0,.184-129.619.333-289.474.333-159.911,0-289.5-.148-289.5-.333s129.591-.333,289.5-.333c159.855,0,289.474.148,289.474.333",
    transform: "translate(0 118.068)",
    fill: "#263238"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_78",
    "data-name": "Ret\\xE2ngulo 78",
    width: 345.385,
    height: 234.296,
    transform: "translate(28.291 0.305)",
    fill: "#fafafa"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    d: "M368.833,234.748H22.923V.1h345.91ZM368.569.276H23.184v234.3H368.569",
    transform: "translate(6.425 0.029)",
    fill: "#fafafa"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_45",
    "data-name": "Caminho 45",
    d: "M368.833,234.748H22.923V.1h345.91ZM368.569.276H23.184v234.3H368.569",
    transform: "translate(6.425 0.029)",
    fill: "#fafafa"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_79",
    "data-name": "Ret\\xE2ngulo 79",
    width: 345.648,
    height: 23.227,
    transform: "translate(29.479 0.261)",
    fill: "#4b4c97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74",
    "data-name": "Grupo 74",
    transform: "translate(29.479 198.751)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_73",
    "data-name": "Grupo 73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_72",
    "data-name": "Grupo 72",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_80",
    "data-name": "Ret\\xE2ngulo 80",
    width: 345.648,
    height: 36.026,
    transform: "translate(0)",
    fill: "#ebebeb"
  }))))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_46",
    "data-name": "Caminho 46",
    d: "M74.6,169.751h2.854l.9,1.869h.613l-2.856-5.964h-.157l-2.863,5.964h.62Zm1.43-2.973,1.155,2.417H74.868Z",
    transform: "translate(20.486 46.434)",
    fill: "#263238"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_82",
    "data-name": "Ret\\xE2ngulo 82",
    width: 6.757,
    height: 0.476,
    transform: "translate(93.115 219.325)",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_47",
    "data-name": "Caminho 47",
    d: "M42.088,165.4h-.456a2.515,2.515,0,0,0-2.374,2.562,10.641,10.641,0,0,0,2.374,5.083s.178.312.456,0a10.641,10.641,0,0,0,2.374-5.083,2.515,2.515,0,0,0-2.374-2.562m-.228,4.056a1.4,1.4,0,1,1,1.4-1.4,1.4,1.4,0,0,1-1.4,1.4",
    transform: "translate(11.004 46.361)",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M66.895,171.355a1.447,1.447,0,0,1-2.893,0v-4.673a.936.936,0,0,1,1.872,0v3.963h.005a.532.532,0,0,1-1.04-.008v-3.051h-.35v3.059H64.5a.864.864,0,0,0,1.713,0h.008v-.078c0-.022.005-.042.005-.065h-.005v-3.863h0a1.285,1.285,0,0,0-2.568,0h0v4.881h.009a1.794,1.794,0,0,0,3.573,0h.008v-3.933h-.348Z",
    transform: "translate(17.842 46.361)",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_49",
    "data-name": "Caminho 49",
    d: "M55.412,167.881l-1.339-2.71-1.338,2.71-2.992.435,2.165,2.111-.512,2.981L54.073,172l2.677,1.407-.512-2.981,2.166-2.111Zm.758,4.731-2.1-1.1-2.1,1.1.382-2.221.022-.114-1.7-1.654,2.347-.341,1.046-2.125,1.051,2.125,2.342.341L55.853,170.2l-.081.079Z",
    transform: "translate(13.943 46.298)",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_50",
    "data-name": "Caminho 50",
    d: "M95.414,162.57h-.435v13.887h.435ZM95.2,176.456v0Z",
    transform: "translate(26.623 45.569)",
    fill: "#263238"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_83",
    "data-name": "Ret\\xE2ngulo 83",
    width: 5.528,
    height: 5.892,
    transform: "translate(108.01 213.053)",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_51",
    "data-name": "Caminho 51",
    d: "M86.11,165.331v.453h2.037v-.453h1.745v.906H84.363v-.906Z",
    transform: "translate(23.647 46.343)",
    fill: "#263238"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_84",
    "data-name": "Ret\\xE2ngulo 84",
    width: 2.037,
    height: 0.453,
    transform: "translate(109.757 211.221)",
    fill: "#263238"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_85",
    "data-name": "Ret\\xE2ngulo 85",
    width: 2.037,
    height: 0.453,
    transform: "translate(109.757 211.674)",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_52",
    "data-name": "Caminho 52",
    d: "M105.512,169.245l1.7-1.7.206.206-1.9,1.9-1.9-1.9.206-.206Z",
    transform: "translate(29.042 46.964)",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_53",
    "data-name": "Caminho 53",
    d: "M267.819,9.585h4.792V9.33h0V9.077h-4.792Z",
    transform: "translate(75.071 2.544)",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_54",
    "data-name": "Caminho 54",
    d: "M287.615,7.622l-.36-.36L285.039,9.48l-2.216-2.217-.358.36,2.216,2.216-2.216,2.217.358.36,2.216-2.217,2.216,2.217.36-.36L285.4,9.838Z",
    transform: "translate(79.176 2.036)",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_55",
    "data-name": "Caminho 55",
    d: "M274.919,12.506h5.3V7.2h-5.3Zm.51-4.792h4.284V12h-4.284Z",
    transform: "translate(77.061 2.019)",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_56",
    "data-name": "Caminho 56",
    d: "M289.379,60.147a1.882,1.882,0,0,0-1.818-1.878v0h-7.142v.012a2.626,2.626,0,0,0,0,5.23v.013h5.756v-.512H280.66a2.116,2.116,0,1,1,0-4.231H287.5a1.37,1.37,0,0,1,0,2.74h-5.8v.005A.777.777,0,0,1,281.71,60h4.466v-.512H281.7v.02a1.264,1.264,0,0,0,0,2.5v.012h.115c.032,0,.063.01.095.01v-.01h5.653v0a1.884,1.884,0,0,0,1.818-1.878",
    transform: "translate(77.934 16.332)",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_57",
    "data-name": "Caminho 57",
    d: "M36.5,6.194v6.359h-.745L31.939,7.811v4.742h-.908V6.194h.744l3.815,4.742V6.194Z",
    transform: "translate(8.698 1.736)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_58",
    "data-name": "Caminho 58",
    d: "M41.117,10.107H37.211a1.631,1.631,0,0,0,1.744,1.408,1.8,1.8,0,0,0,1.39-.581l.481.563a2.624,2.624,0,0,1-4.487-1.681,2.357,2.357,0,0,1,2.417-2.452,2.321,2.321,0,0,1,2.379,2.48c0,.072-.009.181-.018.262m-3.906-.626H40.3a1.554,1.554,0,0,0-3.089,0",
    transform: "translate(10.186 2.064)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_59",
    "data-name": "Caminho 59",
    d: "M48.408,7.4l-1.8,4.815h-.836L44.384,8.563l-1.408,3.653h-.835L40.35,7.4h.827l1.4,3.835L44.029,7.4h.736l1.426,3.852L47.627,7.4Z",
    transform: "translate(11.31 2.074)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_60",
    "data-name": "Caminho 60",
    d: "M53.946,11.763v.79H49.331V6.194h4.487v.791H50.24V8.937h3.188v.772H50.24v2.054Z",
    transform: "translate(13.828 1.736)",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_61",
    "data-name": "Caminho 61",
    d: "M61.975,9.454v2.771H61.1V9.554c0-.945-.455-1.408-1.244-1.408a1.4,1.4,0,0,0-1.444,1.6v2.48h-.872V9.554c0-.945-.455-1.408-1.246-1.408a1.4,1.4,0,0,0-1.444,1.6v2.48h-.872V7.41h.836v.718a1.951,1.951,0,0,1,1.662-.763,1.782,1.782,0,0,1,1.672.89A2.17,2.17,0,0,1,60,7.365a1.846,1.846,0,0,1,1.972,2.089",
    transform: "translate(15.131 2.064)",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_62",
    "data-name": "Caminho 62",
    d: "M65.369,9.318v2.906h-.826v-.635a1.79,1.79,0,0,1-1.581.69c-1.09,0-1.78-.581-1.78-1.417,0-.772.5-1.408,1.935-1.408H64.5V9.282c0-.736-.426-1.164-1.289-1.164a2.438,2.438,0,0,0-1.526.519l-.364-.654a3.208,3.208,0,0,1,1.99-.618c1.317,0,2.061.636,2.061,1.954M64.5,10.753v-.672H63.152c-.863,0-1.107.335-1.107.745,0,.481.4.781,1.063.781a1.4,1.4,0,0,0,1.389-.854",
    transform: "translate(17.15 2.064)",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_63",
    "data-name": "Caminho 63",
    d: "M65.59,6.361a.574.574,0,0,1,.59-.571.564.564,0,0,1,.59.553.591.591,0,0,1-1.18.018m.155,1.49h.872v4.815h-.872Z",
    transform: "translate(18.385 1.623)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_86",
    "data-name": "Ret\\xE2ngulo 86",
    width: 0.872,
    height: 6.741,
    transform: "translate(86.661 7.549)",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_64",
    "data-name": "Caminho 64",
    d: "M31.8,24.7h-2.18v-.79h5.259v.79h-2.18v5.569h-.9Z",
    transform: "translate(8.301 6.703)",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_65",
    "data-name": "Caminho 65",
    d: "M33.655,27.536A2.5,2.5,0,1,1,36.162,30a2.395,2.395,0,0,1-2.507-2.462m4.124,0a1.623,1.623,0,1,0-1.617,1.7,1.58,1.58,0,0,0,1.617-1.7",
    transform: "translate(9.434 7.031)",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_66",
    "data-name": "Caminho 66",
    d: "M40.091,25.7a.607.607,0,0,1,.618-.617.6.6,0,0,1,.6.617.606.606,0,0,1-.6.627.615.615,0,0,1-.618-.627m0,3.671a.608.608,0,0,1,.618-.618.6.6,0,0,1,.6.618.6.6,0,0,1-.6.626.614.614,0,0,1-.618-.626",
    transform: "translate(11.238 7.031)",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_67",
    "data-name": "Caminho 67",
    d: "M30.626,43.815A3.216,3.216,0,0,1,34,40.563a3.145,3.145,0,0,1,2.416.99l-.59.572a2.359,2.359,0,0,0-1.79-.754,2.445,2.445,0,1,0,0,4.888,2.364,2.364,0,0,0,1.79-.764l.59.574a3.154,3.154,0,0,1-2.426,1,3.214,3.214,0,0,1-3.361-3.252",
    transform: "translate(8.585 11.37)",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_68",
    "data-name": "Caminho 68",
    d: "M35.553,44.243A2.4,2.4,0,0,1,38.1,41.79a2.148,2.148,0,0,1,1.961,1.027l-.663.428a1.5,1.5,0,0,0-1.307-.691,1.695,1.695,0,0,0,0,3.389,1.5,1.5,0,0,0,1.307-.69l.663.417A2.155,2.155,0,0,1,38.1,46.705a2.412,2.412,0,0,1-2.544-2.462",
    transform: "translate(9.966 11.714)",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_69",
    "data-name": "Caminho 69",
    d: "M41.534,42.408a.607.607,0,0,1,.618-.617.6.6,0,0,1,.6.617.606.606,0,0,1-.6.627.615.615,0,0,1-.618-.627m0,3.671a.608.608,0,0,1,.618-.618.6.6,0,0,1,.6.618.6.6,0,0,1-.6.626.614.614,0,0,1-.618-.626",
    transform: "translate(11.642 11.714)",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_70",
    "data-name": "Caminho 70",
    d: "M29.878,63.193l.335-.709a3.271,3.271,0,0,0,2.1.736c1.1,0,1.572-.426,1.572-.981,0-1.553-3.851-.572-3.851-2.934,0-.981.762-1.817,2.434-1.817a3.742,3.742,0,0,1,2.045.563l-.3.726a3.287,3.287,0,0,0-1.744-.517c-1.081,0-1.544.455-1.544,1.008,0,1.554,3.851.583,3.851,2.917,0,.972-.781,1.808-2.462,1.808a3.772,3.772,0,0,1-2.434-.8",
    transform: "translate(8.375 16.114)",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_71",
    "data-name": "Caminho 71",
    d: "M39.131,58.751v4.815H38.3v-.727a1.955,1.955,0,0,1-1.635.781,1.891,1.891,0,0,1-2.07-2.1V58.751h.872v2.671c0,.945.471,1.417,1.3,1.417a1.417,1.417,0,0,0,1.49-1.6V58.751Z",
    transform: "translate(9.698 16.468)",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_72",
    "data-name": "Caminho 72",
    d: "M44.419,61.58a2.344,2.344,0,0,1-2.434,2.462,2.033,2.033,0,0,1-1.717-.818v.763h-.836v-6.74H40.3V59.9a2.05,2.05,0,0,1,1.681-.773,2.337,2.337,0,0,1,2.434,2.453m-.881,0a1.623,1.623,0,1,0-1.626,1.7,1.586,1.586,0,0,0,1.626-1.7",
    transform: "translate(11.053 16.047)",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_73",
    "data-name": "Caminho 73",
    d: "M42.968,65.543l.282-.672a1.1,1.1,0,0,0,.708.228c.463,0,.718-.292.718-.845V59.2h.872v5.033a1.436,1.436,0,0,1-1.535,1.6,1.712,1.712,0,0,1-1.045-.291m1.553-7.83a.575.575,0,0,1,.59-.572.568.568,0,1,1-.59.572",
    transform: "translate(12.044 16.017)",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_74",
    "data-name": "Caminho 74",
    d: "M50.709,61.458H46.8a1.631,1.631,0,0,0,1.744,1.408,1.8,1.8,0,0,0,1.39-.581l.481.563a2.624,2.624,0,0,1-4.487-1.681,2.357,2.357,0,0,1,2.416-2.452,2.321,2.321,0,0,1,2.38,2.48c0,.072-.009.181-.018.262M46.8,60.832h3.089a1.554,1.554,0,0,0-3.089,0",
    transform: "translate(12.875 16.458)",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_75",
    "data-name": "Caminho 75",
    d: "M50.269,61.168a2.406,2.406,0,0,1,2.544-2.453,2.149,2.149,0,0,1,1.963,1.027l-.664.428a1.5,1.5,0,0,0-1.307-.691,1.7,1.7,0,0,0,0,3.389,1.5,1.5,0,0,0,1.307-.69l.664.417a2.155,2.155,0,0,1-1.963,1.036,2.413,2.413,0,0,1-2.544-2.462",
    transform: "translate(14.091 16.458)",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_76",
    "data-name": "Caminho 76",
    d: "M57.572,63.515a1.648,1.648,0,0,1-1.054.335,1.373,1.373,0,0,1-1.526-1.507V59.7h-.818v-.718h.818V57.928h.872v1.054h1.381V59.7H55.864v2.607a.71.71,0,0,0,.754.809,1.094,1.094,0,0,0,.681-.228Z",
    transform: "translate(15.185 16.238)",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_77",
    "data-name": "Caminho 77",
    d: "M59.235,59.333a.607.607,0,0,1,.618-.617.6.6,0,0,1,.6.617.606.606,0,0,1-.6.627.615.615,0,0,1-.618-.627m0,3.671a.608.608,0,0,1,.618-.618.6.6,0,0,1,.6.618.6.6,0,0,1-.6.626A.614.614,0,0,1,59.235,63",
    transform: "translate(16.604 16.458)",
    fill: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_78",
    "data-name": "Caminho 78",
    d: "M141.438,28.061c0,.184-20.388.333-45.53.333s-45.534-.149-45.534-.333,20.382-.333,45.534-.333,45.53.149,45.53.333",
    transform: "translate(14.12 7.772)",
    fill: "#263238"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_79",
    "data-name": "Caminho 79",
    d: "M182.1,44.289c0,.184-29.491.333-65.86.333s-65.865-.149-65.865-.333,29.484-.333,65.865-.333,65.86.149,65.86.333",
    transform: "translate(14.12 12.321)",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_80",
    "data-name": "Caminho 80",
    d: "M128.234,60.391a2.059,2.059,0,0,1-.6.067l-1.732.063-6.372.106c-5.38.06-12.812.1-21.021.1s-15.645-.037-21.025-.1l-6.372-.106-1.732-.063a2.054,2.054,0,0,1-.6-.067,2.054,2.054,0,0,1,.6-.067l1.732-.063,6.372-.106c5.38-.06,12.813-.1,21.025-.1s15.641.037,21.021.1l6.372.106,1.732.063a2.059,2.059,0,0,1,.6.067",
    transform: "translate(19.277 16.835)",
    fill: "#263238"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81",
    "data-name": "Caminho 81",
    d: "M364.914,69.151c0,.184-76.517.333-170.885.333-94.4,0-170.9-.149-170.9-.333s76.5-.333,170.9-.333c94.367,0,170.885.149,170.885.333",
    transform: "translate(6.483 19.29)",
    fill: "#e0e0e0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82",
    "data-name": "Caminho 82",
    d: "M364.943,51.586c0,.186-76.547.333-170.95.333-94.437,0-170.968-.147-170.968-.333s76.532-.332,170.968-.332c94.4,0,170.95.149,170.95.332",
    transform: "translate(6.454 14.367)",
    fill: "#e0e0e0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_83",
    "data-name": "Caminho 83",
    d: "M364.914,36.175c0,.184-76.517.333-170.885.333-94.4,0-170.9-.149-170.9-.333s76.5-.333,170.9-.333c94.367,0,170.885.149,170.885.333",
    transform: "translate(6.483 10.047)",
    fill: "#e0e0e0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84",
    "data-name": "Caminho 84",
    d: "M60.961,90.576c0,.184-4.859.333-10.851.333s-10.852-.149-10.852-.333,4.857-.333,10.852-.333,10.851.149,10.851.333",
    transform: "translate(11.004 25.296)",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85",
    "data-name": "Caminho 85",
    d: "M132.341,103.27c0,.184-20.838.333-46.539.333s-46.543-.149-46.543-.333,20.834-.333,46.543-.333,46.539.149,46.539.333",
    transform: "translate(11.004 28.854)",
    fill: "#263238"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_86",
    "data-name": "Caminho 86",
    d: "M23.186.3C25.906.3,165.015.18,368.571,0h.3V.3c.009,71.31.018,150.728.028,234.268v.361h-.333c-129.993-.024-249.976-.046-345.385-.065h-.268V234.6c.163-142.652.265-232.108.268-234.3,0,2.185.1,91.644.268,234.3l-.268-.268c95.41-.018,215.392-.041,345.385-.064l-.334.332v-.028c.01-83.54.02-162.957.028-234.268l.306.306C165.015.431,25.9.308,23.186.3",
    transform: "translate(6.424 0)",
    fill: "#263238"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_87",
    "data-name": "Caminho 87",
    d: "M339.246,268.959H184.229a12.088,12.088,0,0,1-12.087-12.087V152.185a5.482,5.482,0,0,1,5.482-5.482H345.851a5.482,5.482,0,0,1,5.482,5.482V256.872a12.088,12.088,0,0,1-12.087,12.087",
    transform: "translate(48.252 41.122)",
    fill: "#4b4c97"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_88",
    "data-name": "Caminho 88",
    d: "M339.319,269.032s.128-.018.382-.036.634-.015,1.127-.1a12.01,12.01,0,0,0,9.135-6.445,11.818,11.818,0,0,0,1.273-4.37c.109-1.623.022-3.4.042-5.249-.026-14.886-.061-36.4-.106-62.986q-.01-9.973-.022-20.872,0-5.443-.009-11.1-.006-2.827-.01-5.705a5.239,5.239,0,0,0-2.744-4.5,5.408,5.408,0,0,0-2.707-.616H342.71l-6.011.005-12.306.008-25.689.014-114.388.026h-5.693a10.109,10.109,0,0,0-1.83.085,5.163,5.163,0,0,0-4.24,4.969q0,7.513-.006,14.922,0,14.822-.005,29.186c-.006,19.134-.013,37.591-.019,55.173.022,2.185-.054,4.409.049,6.526a11.808,11.808,0,0,0,6.921,9.733,13.208,13.208,0,0,0,6.02,1.037l24.234.017,43.5.041,62.982.106,17.124.063L337.8,269c1,.012,1.517.035,1.517.035s-.513.023-1.517.035l-4.453.033-17.124.061-62.982.106-43.5.041-24.234.017a13.82,13.82,0,0,1-6.263-1.082,12.408,12.408,0,0,1-7.284-10.223c-.109-2.219-.032-4.367-.058-6.577-.005-17.582-.013-36.039-.019-55.173q0-14.352-.005-29.186,0-7.413,0-14.933a5.808,5.808,0,0,1,4.79-5.613,10.55,10.55,0,0,1,1.946-.095h5.693l114.388.026,25.689.014,12.306.008,6.011.005h2.969a5.98,5.98,0,0,1,2.968.688,5.786,5.786,0,0,1,3.027,4.971v5.715q-.006,5.658-.01,11.1-.012,10.887-.022,20.872c-.045,26.584-.081,48.1-.1,62.986-.032,1.863.047,3.6-.074,5.271a11.984,11.984,0,0,1-1.325,4.439,12.333,12.333,0,0,1-5.053,5.106,11.948,11.948,0,0,1-4.248,1.316,11.728,11.728,0,0,1-1.517.07",
    transform: "translate(48.18 41.048)",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_89",
    "data-name": "Caminho 89",
    d: "M261.989,242.193H230.866s-9.577,15.968,0,25.545h32.189s-15.867-10.39-1.067-25.545",
    transform: "translate(63.52 67.888)",
    fill: "#4b4c97"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_77",
    "data-name": "Grupo 77",
    transform: "translate(292.807 310.081)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_76",
    "data-name": "Grupo 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_75",
    "data-name": "Grupo 75",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_90",
    "data-name": "Caminho 90",
    d: "M230.279,242.193l-1.577,3.166,28.524,2.235a67.019,67.019,0,0,1,4.176-5.4Z",
    transform: "translate(-228.701 -242.193)"
  }))))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_91",
    "data-name": "Caminho 91",
    d: "M249.395,233.7a3.528,3.528,0,1,1-3.527-3.527,3.528,3.528,0,0,1,3.527,3.527",
    transform: "translate(67.929 64.518)",
    fill: "#fafafa"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_88",
    "data-name": "Ret\\xE2ngulo 88",
    width: 162.009,
    height: 93.24,
    transform: "translate(228.985 194.56)",
    fill: "#fafafa"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_92",
    "data-name": "Caminho 92",
    d: "M340.935,245.277s-.018-.58-.027-1.685-.017-2.749-.029-4.883c-.014-4.29-.036-10.583-.064-18.662-.033-16.148-.079-39.426-.137-68.01l.257.256-162,.077h-.012l.333-.333c-.008,32.995-.015,64.525-.023,93.239l-.31-.31,116.515.15,33.467.085,8.924.038,2.307.019c.521.005.8.018.8.018s-.25.013-.758.018l-2.273.019-8.861.038-33.4.083c-28.67.038-69.2.09-116.722.151h-.311v-.311c-.006-28.715-.014-60.245-.023-93.239V151.7h.346l162,.077h.257v.257c-.058,28.651-.1,51.982-.137,68.169-.028,8.053-.05,14.327-.065,18.6-.012,2.113-.022,3.73-.028,4.836-.009,1.087-.027,1.631-.027,1.631",
    transform: "translate(50.06 42.523)",
    fill: "#263238"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_89",
    "data-name": "Ret\\xE2ngulo 89",
    width: 38.129,
    height: 83.065,
    transform: "translate(230.801 202.453)",
    fill: "#4b4c97"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_80",
    "data-name": "Grupo 80",
    transform: "translate(230.802 233.891)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_79",
    "data-name": "Grupo 79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_78",
    "data-name": "Grupo 78",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_90",
    "data-name": "Ret\\xE2ngulo 90",
    width: 38.113,
    height: 7.435,
    transform: "translate(0 0.001)"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_83",
    "data-name": "Grupo 83",
    transform: "translate(230.802 249.073)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_82",
    "data-name": "Grupo 82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_81",
    "data-name": "Grupo 81",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_92",
    "data-name": "Ret\\xE2ngulo 92",
    width: 38.113,
    height: 7.435,
    transform: "translate(0 0.001)"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_86",
    "data-name": "Grupo 86",
    transform: "translate(230.802 267.206)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_85",
    "data-name": "Grupo 85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_84",
    "data-name": "Grupo 84",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_94",
    "data-name": "Ret\\xE2ngulo 94",
    width: 38.113,
    height: 8.223
  }))))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_93",
    "data-name": "Caminho 93",
    d: "M210.241,191.611c0,.184-5.489.333-12.259.333s-12.26-.149-12.26-.333,5.489-.333,12.26-.333,12.259.149,12.259.333",
    transform: "translate(52.059 53.616)",
    fill: "#263238"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94",
    "data-name": "Caminho 94",
    d: "M210.241,185.55c0,.186-5.489.334-12.259.334s-12.26-.149-12.26-.334,5.489-.333,12.26-.333,12.259.149,12.259.333",
    transform: "translate(52.059 51.917)",
    fill: "#263238"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95",
    "data-name": "Caminho 95",
    d: "M218.323,215.2c0,.184-8.458.333-18.89.333s-18.891-.148-18.891-.333,8.456-.333,18.891-.333,18.89.148,18.89.333",
    transform: "translate(50.607 60.229)",
    fill: "#263238"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_96",
    "data-name": "Caminho 96",
    d: "M204.435,197.731c0,.184-4.189.333-9.356.333s-9.356-.149-9.356-.333,4.188-.333,9.356-.333,9.356.149,9.356.333",
    transform: "translate(52.059 55.332)",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_97",
    "data-name": "Caminho 97",
    d: "M206.5,211.292c0,.186-4.189.334-9.356.334s-9.356-.149-9.356-.334,4.188-.332,9.356-.332,9.356.148,9.356.332",
    transform: "translate(52.637 59.133)",
    fill: "#263238"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_98",
    "data-name": "Caminho 98",
    d: "M210.241,204.438c0,.184-5.489.333-12.259.333s-12.26-.149-12.26-.333,5.489-.333,12.26-.333,12.259.149,12.259.333",
    transform: "translate(52.059 57.212)",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_99",
    "data-name": "Caminho 99",
    d: "M210.241,219c0,.184-5.489.333-12.259.333s-12.26-.149-12.26-.333,5.489-.333,12.26-.333,12.259.149,12.259.333",
    transform: "translate(52.059 61.294)",
    fill: "#263238"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_100",
    "data-name": "Caminho 100",
    d: "M196.746,162.505a9.076,9.076,0,0,0-4.1,17.178V176.9a4.276,4.276,0,0,1,8.552,0v2.589a9.078,9.078,0,0,0-4.455-16.988m.179,9.472a3.2,3.2,0,1,1,3.2-3.2,3.2,3.2,0,0,1-3.2,3.2",
    transform: "translate(52.603 45.551)",
    fill: "#fafafa"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_101",
    "data-name": "Caminho 101",
    d: "M195.834,170.412a4.276,4.276,0,0,0-4.276,4.276v2.778a9.03,9.03,0,0,0,8.552-.189v-2.589a4.276,4.276,0,0,0-4.276-4.276",
    transform: "translate(53.695 47.767)",
    fill: "#4b4c97"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_102",
    "data-name": "Caminho 102",
    d: "M195.6,164.9a3.2,3.2,0,1,0,3.2,3.2,3.2,3.2,0,0,0-3.2-3.2",
    transform: "translate(53.93 46.223)",
    fill: "#4b4c97"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_103",
    "data-name": "Caminho 103",
    d: "M205.944,171.647c-.074,0-.04-.809-.41-2.185a9.051,9.051,0,0,0-3.32-4.845,8.82,8.82,0,0,0-8.34-1.21,8.688,8.688,0,0,0-4.061,3.066,8.732,8.732,0,0,0,0,10.347,8.682,8.682,0,0,0,4.061,3.066,8.82,8.82,0,0,0,8.34-1.21,9.06,9.06,0,0,0,3.32-4.845c.37-1.376.335-2.189.41-2.185a1.908,1.908,0,0,1,.038.583,7.174,7.174,0,0,1-.2,1.666,9.051,9.051,0,0,1-3.285,5.157,9.187,9.187,0,0,1-3.911,1.786,9.342,9.342,0,0,1-4.924-.374,9.242,9.242,0,0,1-4.379-3.257,9.33,9.33,0,0,1,0-11.122,9.294,9.294,0,0,1,13.213-1.844,9.041,9.041,0,0,1,3.287,5.156,7.19,7.19,0,0,1,.2,1.667,1.908,1.908,0,0,1-.038.583",
    transform: "translate(52.543 45.49)",
    fill: "#fafafa"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_96",
    "data-name": "Ret\\xE2ngulo 96",
    width: 119.39,
    height: 11.171,
    transform: "translate(268.932 230.245)",
    fill: "#ebebeb"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_97",
    "data-name": "Ret\\xE2ngulo 97",
    width: 119.39,
    height: 5.603,
    transform: "translate(268.932 202.455)",
    fill: "#f5f5f5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_104",
    "data-name": "Caminho 104",
    d: "M294.174,161.633H213.553a.921.921,0,0,1-.922-.922v-.35a.921.921,0,0,1,.922-.922h80.621a.921.921,0,0,1,.922.922v.35a.921.921,0,0,1-.922.922",
    transform: "translate(59.602 44.692)",
    fill: "#e0e0e0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_105",
    "data-name": "Caminho 105",
    d: "M286.69,161.633h-5.363a.921.921,0,0,1-.921-.922v-.35a.921.921,0,0,1,.921-.922h5.363a.921.921,0,0,1,.922.922v.35a.921.921,0,0,1-.922.922",
    transform: "translate(78.599 44.692)",
    fill: "#e0e0e0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_98",
    "data-name": "Ret\\xE2ngulo 98",
    width: 0.903,
    height: 0.903,
    transform: "translate(370.036 203.976)",
    fill: "#e0e0e0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_99",
    "data-name": "Ret\\xE2ngulo 99",
    width: 0.903,
    height: 0.903,
    transform: "translate(370.036 205.171)",
    fill: "#e0e0e0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_100",
    "data-name": "Ret\\xE2ngulo 100",
    width: 0.903,
    height: 0.903,
    transform: "translate(371.442 203.976)",
    fill: "#e0e0e0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_101",
    "data-name": "Ret\\xE2ngulo 101",
    width: 0.903,
    height: 0.903,
    transform: "translate(371.442 205.171)",
    fill: "#e0e0e0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_102",
    "data-name": "Ret\\xE2ngulo 102",
    width: 119.39,
    height: 11.171,
    transform: "translate(268.932 208.057)",
    fill: "#e0e0e0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_103",
    "data-name": "Ret\\xE2ngulo 103",
    width: 3.38,
    height: 3.38,
    transform: "translate(272.233 211.704)",
    fill: "#4b4c97"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_106",
    "data-name": "Caminho 106",
    d: "M266.774,166.739c0,.184-10.958.333-24.473.333s-24.474-.149-24.474-.333,10.956-.333,24.474-.333,24.473.149,24.473.333",
    transform: "translate(61.058 46.644)",
    fill: "#263238"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_107",
    "data-name": "Caminho 107",
    d: "M293.293,166.667c0,.184-1.234.333-2.758.333s-2.758-.149-2.758-.333,1.235-.333,2.758-.333,2.758.149,2.758.333",
    transform: "translate(80.665 46.624)",
    fill: "#263238"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_104",
    "data-name": "Ret\\xE2ngulo 104",
    width: 119.39,
    height: 11.171,
    transform: "translate(268.932 241.327)",
    fill: "#fafafa"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_105",
    "data-name": "Ret\\xE2ngulo 105",
    width: 3.412,
    height: 3.38,
    transform: "translate(271.778 244.974)",
    fill: "#4b4c97"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_108",
    "data-name": "Caminho 108",
    d: "M266.938,192.725c0,.184-11.063.333-24.707.333s-24.709-.149-24.709-.333,11.061-.333,24.709-.333,24.707.148,24.707.333",
    transform: "translate(60.973 53.928)",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_109",
    "data-name": "Caminho 109",
    d: "M293.71,192.653c0,.184-1.247.333-2.783.333s-2.785-.149-2.785-.333,1.246-.333,2.785-.333,2.783.149,2.783.333",
    transform: "translate(80.768 53.908)",
    fill: "#263238"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_106",
    "data-name": "Ret\\xE2ngulo 106",
    width: 119.39,
    height: 11.171,
    transform: "translate(268.932 252.334)",
    fill: "#e0e0e0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_107",
    "data-name": "Ret\\xE2ngulo 107",
    width: 3.412,
    height: 3.38,
    transform: "translate(271.778 255.98)",
    fill: "#4b4c97"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_110",
    "data-name": "Caminho 110",
    d: "M266.938,201.322c0,.184-11.063.333-24.707.333s-24.709-.148-24.709-.333,11.061-.333,24.709-.333,24.707.148,24.707.333",
    transform: "translate(60.973 56.338)",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_111",
    "data-name": "Caminho 111",
    d: "M293.71,201.25c0,.184-1.247.333-2.783.333s-2.785-.148-2.785-.333,1.246-.333,2.785-.333,2.783.149,2.783.333",
    transform: "translate(80.768 56.318)",
    fill: "#263238"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_108",
    "data-name": "Ret\\xE2ngulo 108",
    width: 119.39,
    height: 11.171,
    transform: "translate(268.932 263.341)",
    fill: "#fafafa"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_109",
    "data-name": "Ret\\xE2ngulo 109",
    width: 3.412,
    height: 3.38,
    transform: "translate(271.778 266.987)",
    fill: "#4b4c97"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_112",
    "data-name": "Caminho 112",
    d: "M266.938,209.919c0,.184-11.063.333-24.707.333s-24.709-.149-24.709-.333,11.061-.333,24.709-.333,24.707.148,24.707.333",
    transform: "translate(60.973 58.748)",
    fill: "#263238"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_113",
    "data-name": "Caminho 113",
    d: "M293.71,209.847c0,.184-1.247.333-2.783.333s-2.785-.149-2.785-.333,1.246-.333,2.785-.333,2.783.148,2.783.333",
    transform: "translate(80.768 58.728)",
    fill: "#263238"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_110",
    "data-name": "Ret\\xE2ngulo 110",
    width: 119.39,
    height: 11.171,
    transform: "translate(268.932 274.348)",
    fill: "#ebebeb"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_111",
    "data-name": "Ret\\xE2ngulo 111",
    width: 3.412,
    height: 3.38,
    transform: "translate(271.778 277.994)",
    fill: "#4b4c97"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_114",
    "data-name": "Caminho 114",
    d: "M266.938,218.516c0,.184-11.063.333-24.707.333s-24.709-.149-24.709-.333,11.061-.333,24.709-.333,24.707.148,24.707.333",
    transform: "translate(60.973 61.158)",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_115",
    "data-name": "Caminho 115",
    d: "M293.71,218.444c0,.184-1.247.334-2.783.334s-2.785-.15-2.785-.334,1.246-.333,2.785-.333,2.783.149,2.783.333",
    transform: "translate(80.768 61.138)",
    fill: "#263238"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_112",
    "data-name": "Ret\\xE2ngulo 112",
    width: 119.406,
    height: 11.171,
    transform: "translate(268.915 219.087)",
    fill: "#fafafa"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_113",
    "data-name": "Ret\\xE2ngulo 113",
    width: 3.38,
    height: 3.38,
    transform: "translate(272.233 222.733)",
    fill: "#4b4c97"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_116",
    "data-name": "Caminho 116",
    d: "M245.839,175.354c0,.184-6.271.333-14.005.333s-14.007-.149-14.007-.333,6.27-.333,14.007-.333,14.005.149,14.005.333",
    transform: "translate(61.058 49.059)",
    fill: "#263238"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_117",
    "data-name": "Caminho 117",
    d: "M293.293,175.606c0,.184-1.234.333-2.758.333s-2.758-.149-2.758-.333,1.235-.333,2.758-.333,2.758.149,2.758.333",
    transform: "translate(80.665 49.13)",
    fill: "#263238"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_118",
    "data-name": "Caminho 118",
    d: "M293.293,184.077c0,.184-1.234.333-2.758.333s-2.758-.149-2.758-.333,1.235-.333,2.758-.333,2.758.149,2.758.333",
    transform: "translate(80.665 51.504)",
    fill: "#263238"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_114",
    "data-name": "Ret\\xE2ngulo 114",
    width: 3.38,
    height: 3.38,
    transform: "translate(272.233 233.891)",
    fill: "#4b4c97"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_119",
    "data-name": "Caminho 119",
    d: "M285.316,184.069c0,.184-15.109.333-33.742.333s-33.746-.149-33.746-.333,15.106-.333,33.746-.333,33.742.149,33.742.333",
    transform: "translate(61.058 51.502)",
    fill: "#263238"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_120",
    "data-name": "Caminho 120",
    d: "M184.87,156.207a1.018,1.018,0,1,1-1.018-1.019,1.018,1.018,0,0,1,1.018,1.019",
    transform: "translate(51.249 43.5)",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_121",
    "data-name": "Caminho 121",
    d: "M187.971,156.207a1.018,1.018,0,1,1-1.018-1.019,1.018,1.018,0,0,1,1.018,1.019",
    transform: "translate(52.118 43.5)",
    fill: "#263238"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_122",
    "data-name": "Caminho 122",
    d: "M191.072,156.207a1.018,1.018,0,1,1-1.019-1.019,1.018,1.018,0,0,1,1.019,1.019",
    transform: "translate(52.987 43.5)",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_123",
    "data-name": "Caminho 123",
    d: "M337.834,242.466c0-2.043-.059-34.366-.154-88.676l.154.152-157.508.047h-.012l.2-.2c0,31.362-.009,61.354-.013,88.676l-.187-.187,157.52.187-157.52.187h-.187v-.187c0-27.323-.008-57.314-.013-88.676v-.2h.211l157.508.047h.154v.154c-.095,54.311-.15,86.634-.154,88.676",
    transform: "translate(50.487 43.052)",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_124",
    "data-name": "Caminho 124",
    d: "M370.261,463.692h-9.629L339.156,270.845H351.79Z",
    transform: "translate(95.067 75.919)",
    fill: "#455a64"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_125",
    "data-name": "Caminho 125",
    d: "M322.744,463.692h-9.628l-21.64-192.847h12.634Z",
    transform: "translate(81.702 75.919)",
    fill: "#455a64"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_126",
    "data-name": "Caminho 126",
    d: "M440.063,273.284H100.676V262.145H440.063Z",
    transform: "translate(28.22 73.481)",
    fill: "#455a64"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_127",
    "data-name": "Caminho 127",
    d: "M155.695,463.692h9.629l20.658-192.847H173.348Z",
    transform: "translate(43.642 75.919)",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_128",
    "data-name": "Caminho 128",
    d: "M91.183,463.692h9.629L122.43,270.845H109.8Z",
    transform: "translate(25.559 75.919)",
    fill: "#263238"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_115",
    "data-name": "Ret\\xE2ngulo 115",
    width: 104.566,
    height: 11.139,
    transform: "translate(128.895 335.626)",
    fill: "#263238"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_116",
    "data-name": "Ret\\xE2ngulo 116",
    width: 72.204,
    height: 3.33,
    transform: "translate(281.35 332.296)",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_129",
    "data-name": "Caminho 129",
    d: "M348.9,387.2l6.83,37.521-46.638,8.736c-.562-4.505,21.891-17.97,21.891-17.97l-5.363-23.86Z",
    transform: "translate(86.636 108.534)",
    fill: "#4b4c97"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_89",
    "data-name": "Grupo 89",
    transform: "translate(429.658 519.268)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_88",
    "data-name": "Grupo 88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_87",
    "data-name": "Grupo 87",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_130",
    "data-name": "Caminho 130",
    d: "M337.589,405.609a1.936,1.936,0,0,1,1.723,1.927,1.862,1.862,0,0,1-1.894,1.726,2.045,2.045,0,0,1-1.815-2.05,1.933,1.933,0,0,1,2.17-1.577",
    transform: "translate(-335.59 -405.582)",
    fill: "#fff"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_92",
    "data-name": "Grupo 92",
    transform: "translate(395.637 529.497)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_91",
    "data-name": "Grupo 91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_90",
    "data-name": "Grupo 90",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_131",
    "data-name": "Caminho 131",
    d: "M355.742,417.326l-.836-3.755-44.4,9.78s-1.908,1.293-1.4,2.712Z",
    transform: "translate(-309.018 -413.571)",
    fill: "#fff"
  }))))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_132",
    "data-name": "Caminho 132",
    d: "M325.559,409.3c.05.227,1.209.117,2.466.639,1.271.489,2.033,1.367,2.226,1.238.2-.083-.393-1.381-1.927-1.987s-2.854-.09-2.765.11",
    transform: "translate(91.255 114.618)",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_133",
    "data-name": "Caminho 133",
    d: "M322.034,411.548c-.012.23,1.049.433,2,1.251.977.79,1.367,1.795,1.593,1.744.22-.005.128-1.369-1.077-2.363s-2.554-.849-2.518-.631",
    transform: "translate(90.268 115.314)",
    fill: "#263238"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_134",
    "data-name": "Caminho 134",
    d: "M321.277,417.283c.216.01.32-1.187-.5-2.325s-1.977-1.434-2.038-1.227c-.094.211.723.75,1.381,1.7.68.928.924,1.877,1.155,1.856",
    transform: "translate(89.343 115.954)",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_135",
    "data-name": "Caminho 135",
    d: "M325.078,405.151c.134.189,1.12-.32,2.424-.474,1.3-.18,2.383.064,2.466-.154.1-.189-1.036-.849-2.568-.647s-2.466,1.116-2.321,1.274",
    transform: "translate(91.117 113.198)",
    fill: "#263238"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_136",
    "data-name": "Caminho 136",
    d: "M325.133,401.448a4.458,4.458,0,0,0,2.334-.449,10.731,10.731,0,0,0,2.3-1.209,11.256,11.256,0,0,0,1.207-.963,2.938,2.938,0,0,0,.6-.681,1.011,1.011,0,0,0-.122-1.232,1.274,1.274,0,0,0-1.1-.334,3.122,3.122,0,0,0-.853.285,8.381,8.381,0,0,0-3.248,2.588c-.895,1.2-1.1,2.124-1.018,2.153.117.056.51-.755,1.456-1.789a9.509,9.509,0,0,1,1.864-1.565,8.888,8.888,0,0,1,1.262-.665c.47-.221.89-.3,1.058-.108.061.074.074.106,0,.27a2.372,2.372,0,0,1-.443.5,12.67,12.67,0,0,1-1.1.937,13.232,13.232,0,0,1-2.1,1.288,16.43,16.43,0,0,0-2.107.973",
    transform: "translate(91.136 111.159)",
    fill: "#263238"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_137",
    "data-name": "Caminho 137",
    d: "M326.311,402.141a3.781,3.781,0,0,0,.193-2.371,7.682,7.682,0,0,0-1.658-3.8,1.965,1.965,0,0,0-1.71-.9,1.111,1.111,0,0,0-.854.835,3.217,3.217,0,0,0-.079.9,5.3,5.3,0,0,0,.293,1.573,5.46,5.46,0,0,0,1.449,2.225c1.138,1.038,2.139,1.132,2.145,1.051.054-.128-.822-.419-1.737-1.449a5.482,5.482,0,0,1-1.15-2.056,4.894,4.894,0,0,1-.21-1.358c-.019-.51.091-.944.287-.928.23-.047.7.252.96.612a8.011,8.011,0,0,1,.816,1.157,8.572,8.572,0,0,1,.889,2.247c.321,1.357.237,2.255.367,2.266",
    transform: "translate(90.315 110.737)",
    fill: "#263238"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_138",
    "data-name": "Caminho 138",
    d: "M306.3,391.921l7.327,37.426L267.114,438.7c-.621-4.5,21.65-18.26,21.65-18.26l-5.678-23.787Z",
    transform: "translate(74.87 109.857)",
    fill: "#4b4c97"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_95",
    "data-name": "Grupo 95",
    transform: "translate(375.636 525.367)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_94",
    "data-name": "Grupo 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_93",
    "data-name": "Grupo 93",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_139",
    "data-name": "Caminho 139",
    d: "M295.373,410.371a1.937,1.937,0,0,1,1.749,1.9,1.862,1.862,0,0,1-1.872,1.75A2.042,2.042,0,0,1,293.409,412a1.932,1.932,0,0,1,2.148-1.606",
    transform: "translate(-293.396 -410.345)",
    fill: "#fff"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_98",
    "data-name": "Grupo 98",
    transform: "translate(341.891 535.462)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_97",
    "data-name": "Grupo 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_96",
    "data-name": "Grupo 96",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_140",
    "data-name": "Caminho 140",
    d: "M313.649,421.974l-.886-3.744L268.494,428.6s-1.89,1.317-1.362,2.728Z",
    transform: "translate(-267.039 -418.23)",
    fill: "#fff"
  }))))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_141",
    "data-name": "Caminho 141",
    d: "M283.4,414.224c.054.225,1.21.1,2.474.606,1.279.472,2.052,1.341,2.243,1.209.2-.086-.411-1.376-1.953-1.961s-2.855-.051-2.764.147",
    transform: "translate(79.436 115.992)",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_142",
    "data-name": "Caminho 142",
    d: "M279.9,416.511c-.008.23,1.054.419,2.019,1.224.987.777,1.392,1.777,1.616,1.722.22-.008.11-1.369-1.109-2.348s-2.564-.816-2.526-.6",
    transform: "translate(78.457 116.703)",
    fill: "#263238"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_143",
    "data-name": "Caminho 143",
    d: "M279.221,422.255c.216.008.3-1.192-.53-2.319s-1.995-1.407-2.052-1.2c-.091.213.732.741,1.4,1.677.691.919.949,1.864,1.179,1.841",
    transform: "translate(77.541 117.356)",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_144",
    "data-name": "Caminho 144",
    d: "M282.857,410.082c.137.188,1.116-.335,2.417-.506,1.3-.2,2.384.032,2.463-.186.1-.191-1.046-.836-2.576-.613s-2.452,1.148-2.3,1.3",
    transform: "translate(79.282 114.569)",
    fill: "#263238"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_145",
    "data-name": "Caminho 145",
    d: "M282.853,406.386a4.458,4.458,0,0,0,2.328-.48,10.684,10.684,0,0,0,2.287-1.239,11.243,11.243,0,0,0,1.195-.979,2.9,2.9,0,0,0,.594-.689,1.01,1.01,0,0,0-.14-1.229,1.269,1.269,0,0,0-1.1-.319,3.088,3.088,0,0,0-.849.3,8.408,8.408,0,0,0-3.214,2.63,3.973,3.973,0,0,0-.99,2.168c.119.055.5-.762,1.433-1.808a9.506,9.506,0,0,1,1.842-1.589,8.845,8.845,0,0,1,1.255-.681c.467-.229.885-.316,1.056-.123.063.074.074.106,0,.271a2.372,2.372,0,0,1-.438.5,12.381,12.381,0,0,1-1.088.95,13.134,13.134,0,0,1-2.079,1.316,16.243,16.243,0,0,0-2.093,1",
    transform: "translate(79.285 112.523)",
    fill: "#263238"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_146",
    "data-name": "Caminho 146",
    d: "M284.051,407.05a3.792,3.792,0,0,0,.161-2.374,7.678,7.678,0,0,0-1.708-3.782,1.963,1.963,0,0,0-1.722-.877,1.107,1.107,0,0,0-.842.845,3.19,3.19,0,0,0-.068.9,5.269,5.269,0,0,0,.314,1.57,5.467,5.467,0,0,0,1.479,2.206c1.152,1.023,2.155,1.1,2.159,1.023.052-.129-.828-.408-1.757-1.428a5.473,5.473,0,0,1-1.177-2.041,4.858,4.858,0,0,1-.228-1.355c-.027-.51.078-.945.274-.932.23-.05.7.243.968.6a7.924,7.924,0,0,1,.831,1.147,8.548,8.548,0,0,1,.919,2.234c.338,1.352.266,2.251.4,2.261",
    transform: "translate(78.449 112.125)",
    fill: "#263238"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_147",
    "data-name": "Caminho 147",
    d: "M322.982,427.231,304.894,326.524a28.794,28.794,0,0,1,28.34-33.885h63.805l41.693,18.479a25.845,25.845,0,0,1-27.867,25.766l-68.088-5.341,9.811,91.22Z",
    transform: "translate(85.336 82.028)",
    fill: "#263238"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_148",
    "data-name": "Caminho 148",
    d: "M282.32,432.563l-20.644-106.04a28.794,28.794,0,0,1,28.341-33.885h63.805l41.694,18.479v27.953l-95.958-7.528,12.569,94.232Z",
    transform: "translate(73.222 82.028)",
    fill: "#263238"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_149",
    "data-name": "Caminho 149",
    d: "M306.916,419.548a7.405,7.405,0,0,1-.219-1.129q-.182-1.2-.5-3.253c-.411-2.892-.992-6.971-1.705-11.986-1.384-10.181-3.281-24.147-5.377-39.573-1.941-14.817-3.705-28.283-5.011-38.258l.106.17c-4.571-3.143-8.051-5.959-10.54-7.792l-2.861-2.119a8.765,8.765,0,0,1-.988-.755,1.065,1.065,0,0,1,.28.147l.786.493c.685.443,1.68,1.12,2.942,2.017,2.539,1.768,6.074,4.531,10.65,7.605l.091.061.015.109,5.19,38.234c2.022,15.437,3.85,29.411,5.184,39.6.626,5.026,1.134,9.114,1.5,12.013q.234,2.063.374,3.27a7.5,7.5,0,0,1,.085,1.147",
    transform: "translate(78.436 88.254)",
    fill: "#455a64"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_150",
    "data-name": "Caminho 150",
    d: "M253.8,262.983l4.527-8.482a2.716,2.716,0,0,1,2.384-1.2l2.023.095,3.445-3.215H270.2l3.1-2.066,11.941,2.3,9.825,2.643-5.594,11.105-5.609-1.182-9.415-.161a10.584,10.584,0,0,1-7.262-3.059,8.943,8.943,0,0,0-6.288-2.584s-2.957,6.612-7.1,5.81",
    transform: "translate(71.141 69.548)",
    fill: "#ffbe9d"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_151",
    "data-name": "Caminho 151",
    d: "M368.779,161.642l.187,61.307-26.3,1.255-.761-14.912s-9.342,1.855-11.752-6.821c-1.54-5.542-1.156-48.374-1.156-48.374Z",
    transform: "translate(92.207 43.194)",
    fill: "#ffbe9d"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_152",
    "data-name": "Caminho 152",
    d: "M371.074,211.728c2.8-2.91,4.092-6.957,4.746-10.943s.764-8.054,1.639-12c.919-4.14,2.667-8.062,3.557-12.209s.808-8.788-1.648-12.245c0,0-1.621-4.75-8.568-5.135,0,0-5.9-9.551-14.613-8.716-11.848,1.134-12.171-2.352-20.332-3.639-7.629-1.2-9.047,5.6-9.047,5.6s-4.194,3.115-4.388,7.6c0,.04,0,.081-.005.12a10.34,10.34,0,0,0,7.07,10.107q.789.267,1.584.521a10.036,10.036,0,0,1,4.157,2.091c1.65,1.644,1.92,4.2,1.835,6.532s-.416,4.735.371,6.926c.268.748.91,1.567,1.677,1.364.914-.243.873-1.517.963-2.459.26-2.744,3.787-4.828,6.267-2.819a4.2,4.2,0,0,1,1.26,5.106c-.921,1.931-2.932,3.441-3.322,5.581-.657,3.605,3.573,6.757,5.185,8.718a14.579,14.579,0,0,0,1.845,1.936c3.49,2.938,6.911,7,11.5,8.591,3.078,1.065,6.824.8,9.164-1.471",
    transform: "translate(90.372 41.122)",
    fill: "#263238"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_153",
    "data-name": "Caminho 153",
    d: "M336.918,207.042c-5.8,4.141-3.415,15.254-3.493,21.084-.175,13.012,1.06,25.219,1.741,27.263.995,2.984,4.6,28.414,4.6,28.414L333.7,317.275s7.834,19.988,41.694,19.788l16.874-4.03A17.52,17.52,0,0,0,405.656,314.5l-3.84-44.951L396.7,233.066c-1.338-19.142-13.328-29.327-28.649-28.237Z",
    transform: "translate(93.343 57.392)",
    fill: "#4b4c97"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_101",
    "data-name": "Grupo 101",
    transform: "translate(442.861 300.955)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_100",
    "data-name": "Grupo 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_99",
    "data-name": "Grupo 99",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_154",
    "data-name": "Caminho 154",
    d: "M347.2,324.2c-3.7-1.927,1.273-39.353,5.6-58.518,1.687-7.472,3.928-15.2,9.237-20.72,4.181-4.349,9.934-6.923,15.819-8.245s10.671-1.488,16.7-1.648l5.311,85.191s-36.727,12.229-52.669,3.94",
    transform: "translate(-345.903 -235.065)"
  }))))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_155",
    "data-name": "Caminho 155",
    d: "M352.175,206.54a22.967,22.967,0,0,0-16.461,12.729c-4.266,8.849-22.919,45.69-22.919,45.69l-28.518-1.9-5.7,13.009,39.133,10.493c8.06,1.543,15.1-3.375,19.077-10.644l16.388-29.983Z",
    transform: "translate(78.086 57.894)",
    fill: "#4b4c97"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_156",
    "data-name": "Caminho 156",
    d: "M338.343,208.417s-.717-6.514.224-7.632,29.229-.931,29.229-.931l1.489,7.469-3.148,5.585-26.911,2.34Z",
    transform: "translate(94.766 56.017)",
    fill: "#4b4c97"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_157",
    "data-name": "Caminho 157",
    d: "M308.612,258.5c-.133.115-1.232-.995-2.073-2.7s-1.068-3.248-.9-3.285c.187-.047.68,1.361,1.494,2.99s1.625,2.878,1.475,3",
    transform: "translate(85.658 70.78)",
    fill: "#263238"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_158",
    "data-name": "Caminho 158",
    d: "M341.84,229.356c.168.076-1.721,4.6-4.217,10.107s-4.656,9.907-4.824,9.831,1.719-4.6,4.217-10.107,4.656-9.907,4.824-9.831",
    transform: "translate(93.282 64.289)",
    fill: "#263238"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_159",
    "data-name": "Caminho 159",
    d: "M368.991,204.755a1.654,1.654,0,0,1,.166.895,2.155,2.155,0,0,1-1.5,2.042l-.013,0-.035,0c-2.964.186-7.73.407-13.1.6-4.564.163-8.661.271-11.688.318a8.107,8.107,0,0,1-3.505-.762,2.562,2.562,0,0,1-1.037-.812c.038-.047.393.26,1.147.576a8.738,8.738,0,0,0,3.4.526c2.943-.165,7.1-.351,11.651-.512,5.375-.191,10.152-.309,13.121-.334l-.047.006a1.937,1.937,0,0,0,1.385-1.67c.064-.556,0-.871.049-.878",
    transform: "translate(94.823 57.394)",
    fill: "#263238"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_160",
    "data-name": "Caminho 160",
    d: "M331.1,212.944c.164.085-5.441,11.239-12.518,24.908s-12.949,24.689-13.112,24.6,5.44-11.236,12.519-24.911,12.946-24.687,13.11-24.6",
    transform: "translate(85.623 59.689)",
    fill: "#263238"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_161",
    "data-name": "Caminho 161",
    d: "M335.231,219.353c0-.037.253-.072.661.1a2.257,2.257,0,0,1,1.221,1.378,2.374,2.374,0,0,1-.912,2.584,2.692,2.692,0,0,1-1.63.46c-.57,0-1.116-.109-1.649-.147a3.134,3.134,0,0,0-2.6.953,3.009,3.009,0,0,0-.844,2.142,5.212,5.212,0,0,0,.67,2.16c-.009.072-.958-.527-1.139-2.136a3.379,3.379,0,0,1,.863-2.584,3.667,3.667,0,0,1,3.1-1.2c1.154.117,2.184.347,2.878-.151a1.9,1.9,0,0,0,.809-1.955,2.167,2.167,0,0,0-.892-1.275c-.321-.221-.547-.278-.535-.33",
    transform: "translate(92.217 61.477)",
    fill: "#fafafa"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_162",
    "data-name": "Caminho 162",
    d: "M364.758,219.679c0-.037.254-.072.661.1a2.257,2.257,0,0,1,1.221,1.378,2.374,2.374,0,0,1-.912,2.584,2.691,2.691,0,0,1-1.63.46c-.57,0-1.116-.109-1.649-.147a3.13,3.13,0,0,0-2.6.953,3.005,3.005,0,0,0-.845,2.142,5.212,5.212,0,0,0,.67,2.16c-.009.072-.958-.527-1.139-2.136a3.381,3.381,0,0,1,.863-2.584,3.667,3.667,0,0,1,3.1-1.2c1.154.118,2.184.347,2.878-.151a1.9,1.9,0,0,0,.809-1.955,2.167,2.167,0,0,0-.892-1.275c-.32-.221-.547-.278-.535-.33",
    transform: "translate(100.494 61.569)",
    fill: "#fafafa"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_163",
    "data-name": "Caminho 163",
    d: "M364.814,242.746c.035.013.009.264-.257.617a2.259,2.259,0,0,1-1.63.857,2.375,2.375,0,0,1-2.29-1.5,2.694,2.694,0,0,1-.056-1.693c.14-.552.373-1.057.538-1.566a3.13,3.13,0,0,0-.3-2.755,3,3,0,0,0-1.877-1.333,5.2,5.2,0,0,0-2.257.133,2.53,2.53,0,0,1,2.347-.6,3.376,3.376,0,0,1,2.3,1.457,3.666,3.666,0,0,1,.422,3.3c-.39,1.092-.86,2.038-.543,2.831a1.907,1.907,0,0,0,1.705,1.255,2.17,2.17,0,0,0,1.452-.562c.291-.259.4-.463.448-.44",
    transform: "translate(99.979 65.836)",
    fill: "#fafafa"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_164",
    "data-name": "Caminho 164",
    d: "M351.868,273.031c.035.012.009.265-.257.618a2.254,2.254,0,0,1-1.63.855,2.373,2.373,0,0,1-2.29-1.5,2.694,2.694,0,0,1-.056-1.693c.14-.552.373-1.059.538-1.566a3.129,3.129,0,0,0-.3-2.755,3,3,0,0,0-1.877-1.333,5.179,5.179,0,0,0-2.257.133,2.526,2.526,0,0,1,2.347-.6,3.376,3.376,0,0,1,2.3,1.457,3.666,3.666,0,0,1,.423,3.3c-.391,1.092-.86,2.038-.543,2.831a1.909,1.909,0,0,0,1.705,1.253,2.18,2.18,0,0,0,1.452-.561c.291-.259.4-.463.448-.442",
    transform: "translate(96.35 74.325)",
    fill: "#fafafa"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_165",
    "data-name": "Caminho 165",
    d: "M377.988,227.016c0-.037.254-.072.661.1a2.257,2.257,0,0,1,1.221,1.378,2.374,2.374,0,0,1-.912,2.584,2.694,2.694,0,0,1-1.63.46c-.57,0-1.116-.109-1.649-.147a3.134,3.134,0,0,0-2.6.953,3.009,3.009,0,0,0-.844,2.142,5.211,5.211,0,0,0,.67,2.16c-.009.072-.958-.527-1.14-2.136a3.381,3.381,0,0,1,.863-2.584,3.666,3.666,0,0,1,3.1-1.2c1.154.116,2.184.347,2.878-.151a1.9,1.9,0,0,0,.809-1.955,2.167,2.167,0,0,0-.892-1.275c-.321-.221-.547-.278-.535-.33",
    transform: "translate(104.202 63.625)",
    fill: "#fafafa"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_166",
    "data-name": "Caminho 166",
    d: "M345.846,254.52c-.033.017-.193-.181-.255-.617a2.258,2.258,0,0,1,.543-1.76,2.378,2.378,0,0,1,2.682-.561,2.693,2.693,0,0,1,1.239,1.155c.292.489.485,1.01.73,1.486a3.126,3.126,0,0,0,2.165,1.731,3.007,3.007,0,0,0,2.269-.389,5.236,5.236,0,0,0,1.5-1.694c.065-.028.045,1.093-1.234,2.083a3.379,3.379,0,0,1-2.657.6,3.667,3.667,0,0,1-2.636-2.029c-.5-1.047-.837-2.047-1.623-2.383a1.9,1.9,0,0,0-2.091.323,2.171,2.171,0,0,0-.627,1.425c-.022.389.046.611,0,.629",
    transform: "translate(96.866 70.466)",
    fill: "#fafafa"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_167",
    "data-name": "Caminho 167",
    d: "M348.6,233.771c0-.037.254-.072.661.1a2.257,2.257,0,0,1,1.221,1.378,2.374,2.374,0,0,1-.912,2.584,2.692,2.692,0,0,1-1.63.46c-.57,0-1.116-.109-1.649-.147a3.13,3.13,0,0,0-2.6.953,3.005,3.005,0,0,0-.845,2.142,5.211,5.211,0,0,0,.67,2.16c-.009.072-.958-.527-1.139-2.136a3.381,3.381,0,0,1,.863-2.584,3.667,3.667,0,0,1,3.1-1.2c1.154.117,2.184.347,2.878-.151a1.9,1.9,0,0,0,.809-1.955,2.167,2.167,0,0,0-.892-1.275c-.32-.221-.547-.278-.535-.33",
    transform: "translate(95.966 65.519)",
    fill: "#fafafa"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_168",
    "data-name": "Caminho 168",
    d: "M348,281.267c0-.037.254-.072.661.1a2.257,2.257,0,0,1,1.221,1.378,2.374,2.374,0,0,1-.912,2.584,2.692,2.692,0,0,1-1.63.46c-.57,0-1.116-.109-1.649-.147a3.134,3.134,0,0,0-2.6.953,3.009,3.009,0,0,0-.844,2.142,5.211,5.211,0,0,0,.67,2.16c-.009.072-.958-.527-1.14-2.136a3.379,3.379,0,0,1,.863-2.584,3.667,3.667,0,0,1,3.1-1.2c1.154.117,2.184.347,2.878-.151a1.9,1.9,0,0,0,.809-1.955,2.167,2.167,0,0,0-.892-1.275c-.321-.221-.547-.278-.535-.33",
    transform: "translate(95.797 78.832)",
    fill: "#fafafa"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_169",
    "data-name": "Caminho 169",
    d: "M319.72,255.955c0-.037.254-.072.661.1a2.257,2.257,0,0,1,1.221,1.378,2.374,2.374,0,0,1-.912,2.584,2.692,2.692,0,0,1-1.63.46c-.57,0-1.116-.109-1.649-.147a3.13,3.13,0,0,0-2.6.953,3.005,3.005,0,0,0-.845,2.142,5.212,5.212,0,0,0,.67,2.16c-.009.072-.958-.527-1.139-2.136a3.379,3.379,0,0,1,.863-2.584,3.667,3.667,0,0,1,3.1-1.2c1.154.117,2.184.347,2.878-.151a1.9,1.9,0,0,0,.809-1.955,2.167,2.167,0,0,0-.892-1.275c-.32-.221-.545-.278-.535-.33",
    transform: "translate(87.869 71.737)",
    fill: "#fafafa"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_170",
    "data-name": "Caminho 170",
    d: "M327.9,243.623c.036.006.049.26-.161.648a2.26,2.26,0,0,1-1.483,1.093,2.378,2.378,0,0,1-2.492-1.143,2.7,2.7,0,0,1-.31-1.664c.055-.567.21-1.1.3-1.629a3.132,3.132,0,0,0-.712-2.68,3,3,0,0,0-2.057-1.034,5.21,5.21,0,0,0-2.211.471c-.07-.015.612-.906,2.23-.942a3.381,3.381,0,0,1,2.494,1.095,3.668,3.668,0,0,1,.914,3.2c-.221,1.138-.543,2.143-.11,2.879a1.9,1.9,0,0,0,1.874.983,2.175,2.175,0,0,0,1.351-.773c.248-.3.325-.519.376-.5",
    transform: "translate(89.351 66.36)",
    fill: "#fafafa"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_171",
    "data-name": "Caminho 171",
    d: "M349.512,218.35c.036.006.049.26-.161.648a2.258,2.258,0,0,1-1.483,1.092,2.375,2.375,0,0,1-2.491-1.142,2.7,2.7,0,0,1-.31-1.664c.055-.567.21-1.1.3-1.629a3.127,3.127,0,0,0-.712-2.68,3,3,0,0,0-2.057-1.034,5.209,5.209,0,0,0-2.211.471c-.07-.017.612-.906,2.23-.942a3.376,3.376,0,0,1,2.494,1.095,3.667,3.667,0,0,1,.914,3.2c-.221,1.139-.543,2.145-.11,2.881a1.9,1.9,0,0,0,1.874.983,2.175,2.175,0,0,0,1.351-.773c.248-.3.325-.518.376-.5",
    transform: "translate(95.409 59.276)",
    fill: "#fafafa"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_172",
    "data-name": "Caminho 172",
    d: "M378.488,216.634c.036.006.049.26-.161.648a2.263,2.263,0,0,1-1.484,1.093,2.377,2.377,0,0,1-2.49-1.143,2.7,2.7,0,0,1-.31-1.664c.055-.567.21-1.1.3-1.629a3.128,3.128,0,0,0-.713-2.68,3,3,0,0,0-2.056-1.034,5.2,5.2,0,0,0-2.211.471c-.07-.015.612-.906,2.23-.942a3.381,3.381,0,0,1,2.494,1.095,3.668,3.668,0,0,1,.914,3.2c-.221,1.138-.543,2.143-.11,2.879a1.9,1.9,0,0,0,1.873.983,2.175,2.175,0,0,0,1.352-.773c.248-.3.325-.519.376-.5",
    transform: "translate(103.532 58.795)",
    fill: "#fafafa"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_173",
    "data-name": "Caminho 173",
    d: "M302.25,261.064c.036.006.049.26-.161.648a2.258,2.258,0,0,1-1.483,1.092,2.375,2.375,0,0,1-2.491-1.142A2.7,2.7,0,0,1,297.8,260c.055-.567.21-1.1.3-1.629a3.128,3.128,0,0,0-.713-2.68,3,3,0,0,0-2.056-1.034,5.21,5.21,0,0,0-2.211.471c-.07-.017.612-.906,2.23-.942a3.376,3.376,0,0,1,2.494,1.095,3.667,3.667,0,0,1,.914,3.2c-.221,1.139-.543,2.145-.11,2.881a1.9,1.9,0,0,0,1.873.983,2.175,2.175,0,0,0,1.352-.773c.248-.3.325-.519.376-.5",
    transform: "translate(82.162 71.249)",
    fill: "#fafafa"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_174",
    "data-name": "Caminho 174",
    d: "M346.914,336.338l-1.011,112.6h6.413l.478-110.356s.32-5.043,4.167-5.379,61.46,2.567,61.46,2.567L435.4,448.935h7.373L426.19,335.781s-48.388-16.366-72.435-11.323c0,0-5.772-1.064-6.092,3.362s-.749,8.518-.749,8.518",
    transform: "translate(96.958 90.677)",
    fill: "#e0e0e0"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_175",
    "data-name": "Caminho 175",
    d: "M362.717,347.052s10.007-78.068,13.61-91.329a23.93,23.93,0,0,1,11.1-14.177,18.82,18.82,0,0,1,10.159-2.691l53.147,1.165a8.031,8.031,0,0,1,7.752,9.3L440.865,359.506c-19.559-.049-65.319,0-65.319,0s-62.6-6.834-72.21-7.253c-6.01-.262-6.463,2.047-6.965,4.567h0c-5.635-4.566-2.273-13.944,4.966-13.5Z",
    transform: "translate(82.281 66.951)",
    fill: "#455a64"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_176",
    "data-name": "Caminho 176",
    d: "M440.407,244.015a2.326,2.326,0,0,1-.456.035l-1.339.032-5.151.063-18.94.106-13.078.041-7.286.017-3.81.008c-1.287.008-2.6-.024-3.882.081a14.317,14.317,0,0,0-12.057,9.524,23.992,23.992,0,0,0-.9,4.193q-.353,2.166-.713,4.365-.72,4.4-1.458,8.916c-3.982,24.065-7.585,45.845-10.2,61.657-1.332,7.855-2.412,14.224-3.166,18.673-.383,2.17-.684,3.872-.895,5.071-.1.551-.186.986-.248,1.316a2.3,2.3,0,0,1-.108.444,2.35,2.35,0,0,1,.04-.456c.046-.333.108-.771.184-1.326.182-1.2.44-2.911.771-5.092.7-4.457,1.713-10.838,2.956-18.707,2.567-15.819,6.1-37.613,10.008-61.69q.739-4.513,1.462-8.915.361-2.2.717-4.365a24.6,24.6,0,0,1,.935-4.3,14.936,14.936,0,0,1,12.614-9.922c1.357-.1,2.654-.065,3.942-.07l3.81.008,7.286.017,13.078.041,18.94.106,5.151.063,1.339.032a2.325,2.325,0,0,1,.456.035",
    transform: "translate(99.989 68.313)",
    fill: "#263238"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_177",
    "data-name": "Caminho 177",
    d: "M296.314,335.63l-2.918,112.6h6.413l1.662-110.181s.078-6.559,5.075-6.012c3.84.42,62.015,7.182,62.015,7.182l19.586,109.01h7.375L375.589,335.073l-71.3-8.984a7.617,7.617,0,0,0-4.352.658,6.339,6.339,0,0,0-3.521,5.637c-.312,4.429-.1,3.246-.1,3.246",
    transform: "translate(82.24 91.385)",
    fill: "#ebebeb"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_178",
    "data-name": "Caminho 178",
    d: "M426.644,239.639s-35.9,116.72-79.072,107.228l.714-5.5s33.369,5.544,72.632-101.851Z",
    transform: "translate(97.426 67.137)",
    fill: "#4b4c97"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_179",
    "data-name": "Caminho 179",
    d: "M349.982,328.672A100.472,100.472,0,0,0,357,364.149c1.3,3.276,3,6.734,6.175,8.266,3.143,1.517,6.87.731,10.233-.2a155.736,155.736,0,0,0,24.409-8.984c2.886-1.346,5.914-2.952,7.39-5.773,1.763-3.363.835-7.448-.173-11.11q-4.845-17.639-10.876-34.928c-.836-2.4-4.68-11.661-4.68-11.661",
    transform: "translate(98.102 84.025)",
    fill: "#4b4c97"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_180",
    "data-name": "Caminho 180",
    d: "M393.379,310.556a2.331,2.331,0,0,1,.017.625c0,.41-.045,1.01-.111,1.783a37.341,37.341,0,0,1-1.223,6.464,33.792,33.792,0,0,1-3.98,8.919,28.5,28.5,0,0,1-8.389,8.509,24.221,24.221,0,0,1-11.271,3.945,22.073,22.073,0,0,1-9.656-1.434,19.315,19.315,0,0,1-5.64-3.4,13.587,13.587,0,0,1-1.27-1.264,2.265,2.265,0,0,1-.389-.49c.052-.049.624.594,1.824,1.554a20.661,20.661,0,0,0,5.642,3.157,22.158,22.158,0,0,0,9.438,1.262,24.025,24.025,0,0,0,10.957-3.891,28.507,28.507,0,0,0,8.237-8.285,34.737,34.737,0,0,0,4.044-8.718,43.519,43.519,0,0,0,1.415-6.362c.224-1.527.3-2.381.353-2.378",
    transform: "translate(98.518 87.05)",
    fill: "#263238"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_181",
    "data-name": "Caminho 181",
    d: "M370.95,338.344c-.183-.013-.164-2.515.044-5.586s.525-5.555.709-5.542.164,2.513-.044,5.587-.526,5.554-.709,5.541",
    transform: "translate(103.944 91.72)",
    fill: "#263238"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_182",
    "data-name": "Caminho 182",
    d: "M68.156,367.329c9.324,3.256,21.487.347,29.464-5.478s13.715-14.169,18.8-22.634c2.171-3.613,4.29-7.38,4.977-11.537s-.324-8.837-3.549-11.551c-5.012-4.217-12.692-2.078-18.383,1.164a63.393,63.393,0,0,0-31.311,50.037",
    transform: "translate(19.104 87.955)",
    fill: "#4b4c97"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_183",
    "data-name": "Caminho 183",
    d: "M75.975,376.275c5.6,7.387,15.22,10.677,24.481,11.105s18.41-2.132,27.064-5.453c3.141-1.2,6.576-2.856,7.652-6.042a7.682,7.682,0,0,0-1.639-7.128,15.973,15.973,0,0,0-6.249-4.26c-8.52-3.63-18.279-3.8-27.242-1.475s-16.794,7.521-24.067,13.251",
    transform: "translate(21.296 101.326)",
    fill: "#4b4c97"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_184",
    "data-name": "Caminho 184",
    d: "M68.895,336.6c7.719.154,13.561-6.608,17.055-13.491a50.005,50.005,0,0,0,4.6-31.179c-.705-3.945-2.2-8.2-5.727-10.094-3.587-1.928-8.254-.658-11.262,2.087S68.9,290.587,67.7,294.477c-4.143,13.406-3.251,28.812,1.192,42.122",
    transform: "translate(18.229 78.74)",
    fill: "#4b4c97"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_185",
    "data-name": "Caminho 185",
    d: "M50.988,376.031c13.16-22.4,15.353-49.8,7.581-74.589-1.261-4.02-3.64-8.622-7.846-8.888-4.658-.3-7.577,4.9-8.864,9.383-4.512,15.739-3.553,32.458-2.555,48.8.616,10.067,4.073,18.674,11.684,25.292",
    transform: "translate(10.783 82.001)",
    fill: "#4b4c97"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_186",
    "data-name": "Caminho 186",
    d: "M47.219,372.621a53.827,53.827,0,0,0-31.933-33.864c-3.5-1.315-7.938-2.065-10.545.608-2.557,2.623-1.769,7.007-.129,10.282,2.65,5.29,6.952,9.54,11.237,13.619,3.9,3.709,7.948,7.433,12.879,9.589s13.983,2.705,18.491-.234",
    transform: "translate(0.867 94.621)",
    fill: "#4b4c97"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_187",
    "data-name": "Caminho 187",
    d: "M114.514,320c.006.009-.072.078-.229.2l-.709.549-2.758,2.063-2,1.477c-.718.556-1.47,1.2-2.294,1.868-1.629,1.361-3.554,2.826-5.491,4.669l-3.1,2.819c-1.073.986-2.106,2.1-3.224,3.2-2.265,2.178-4.458,4.719-6.818,7.345a144.98,144.98,0,0,0-24.054,38.914c-1.293,3.285-2.585,6.384-3.521,9.383-.488,1.493-1.022,2.915-1.422,4.316s-.773,2.749-1.136,4.036c-.782,2.557-1.232,4.934-1.721,7-.229,1.036-.47,1.995-.645,2.887q-.232,1.337-.426,2.451l-.612,3.389c-.07.356-.128.645-.174.88a1.216,1.216,0,0,1-.081.3,1.046,1.046,0,0,1,.018-.306c.029-.237.067-.529.113-.889q.182-1.244.5-3.412c.113-.745.238-1.568.374-2.465.159-.9.383-1.862.6-2.9.458-2.078.878-4.47,1.636-7.042q.526-1.942,1.1-4.06c.392-1.41.915-2.84,1.394-4.34.918-3.019,2.2-6.137,3.481-9.44a141.831,141.831,0,0,1,24.149-39.07c2.381-2.625,4.6-5.162,6.887-7.334,1.128-1.1,2.174-2.207,3.26-3.187l3.139-2.8c1.963-1.827,3.913-3.272,5.567-4.612.836-.657,1.6-1.288,2.331-1.832l2.037-1.437,2.829-1.97.745-.5a1.13,1.13,0,0,1,.265-.152",
    transform: "translate(15.161 89.699)",
    fill: "#263238"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_188",
    "data-name": "Caminho 188",
    d: "M131.821,369.034a5.115,5.115,0,0,1-.9-.151c-.59-.1-1.443-.333-2.563-.519a72.135,72.135,0,0,0-9.528-1.166,69.526,69.526,0,0,0-56.45,23.49,72.216,72.216,0,0,0-5.888,7.579c-.658.927-1.1,1.691-1.438,2.184a4.854,4.854,0,0,1-.53.746,5.192,5.192,0,0,1,.423-.81c.306-.515.714-1.3,1.343-2.252a64.316,64.316,0,0,1,5.76-7.737,68.4,68.4,0,0,1,56.807-23.637,63.994,63.994,0,0,1,9.55,1.366c1.116.223,1.963.489,2.544.634a5.1,5.1,0,0,1,.873.273",
    transform: "translate(15.282 102.755)",
    fill: "#263238"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_189",
    "data-name": "Caminho 189",
    d: "M83.34,288.617a1.54,1.54,0,0,1-.051.348c-.054.26-.123.591-.21,1.006l-.864,3.855c-.758,3.347-1.914,8.176-3.367,14.136-2.9,11.923-7.113,28.341-11.5,46.534-2.18,9.1-4.155,17.8-5.857,25.726-1.668,7.934-3.093,15.1-4.152,21.137-.568,3.014-1,5.754-1.4,8.157s-.732,4.473-.981,6.171c-.257,1.661-.461,2.966-.607,3.9-.072.417-.128.75-.173,1.013a1.574,1.574,0,0,1-.081.343,1.577,1.577,0,0,1,.017-.351c.029-.265.067-.6.113-1.022.118-.94.283-2.252.493-3.92.21-1.7.494-3.783.876-6.192s.771-5.156,1.311-8.177c1.005-6.055,2.386-13.232,4.027-21.179,1.672-7.94,3.631-16.647,5.813-25.753,4.391-18.2,8.672-34.6,11.679-46.5,1.494-5.914,2.707-10.716,3.558-14.086.416-1.629.744-2.91.978-3.828.111-.408.2-.735.27-.992a1.471,1.471,0,0,1,.113-.333",
    transform: "translate(15.161 80.901)",
    fill: "#263238"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_190",
    "data-name": "Caminho 190",
    d: "M55.325,414.352a.976.976,0,0,1-.083-.271c-.05-.218-.11-.483-.184-.808q-.238-1.145-.648-3.118c-.557-2.709-1.3-6.642-2.139-11.516-1.687-9.743-3.689-23.277-4.919-38.327-.6-7.528-.928-14.716-1.073-21.257-.109-6.541-.052-12.436.152-17.378.06-2.474.223-4.706.332-6.668s.238-3.649.366-5.026q.184-2,.292-3.171c.037-.33.067-.6.092-.823a.966.966,0,0,1,.051-.278.953.953,0,0,1,.012.284c-.008.223-.018.5-.031.827-.042.778-.1,1.84-.175,3.178-.091,1.379-.193,3.066-.261,5.029s-.206,4.192-.239,6.663c-.147,4.937-.159,10.821-.019,17.351.177,6.53.525,13.7,1.12,21.22,1.228,15.027,3.159,28.551,4.733,38.305.787,4.879,1.46,8.821,1.945,11.543q.336,1.984.533,3.139c.05.329.09.6.124.819a.966.966,0,0,1,.02.283",
    transform: "translate(12.957 85.692)",
    fill: "#263238"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_191",
    "data-name": "Caminho 191",
    d: "M65.717,406.254a4.313,4.313,0,0,1-.343-.773c-.22-.574-.508-1.321-.867-2.253q-.28-.743-.617-1.629-.394-.88-.845-1.892t-.965-2.177c-.341-.771-.782-1.548-1.2-2.385l-1.343-2.611q-.772-1.325-1.6-2.751c-1.058-1.932-2.424-3.851-3.742-5.942a140.821,140.821,0,0,0-9.912-12.667,156.1,156.1,0,0,0-11.376-11.386c-1.891-1.6-3.623-3.191-5.373-4.528l-2.49-1.984-2.365-1.744c-1.493-1.133-2.9-2.081-4.133-2.908-1.224-.848-2.293-1.554-3.192-2.093l-2.04-1.292a4.478,4.478,0,0,1-.69-.488,4.237,4.237,0,0,1,.753.379l2.1,1.195c.921.508,2.011,1.187,3.257,2.009,1.257.8,2.685,1.727,4.2,2.842l2.4,1.718,2.523,1.964c1.771,1.325,3.522,2.913,5.432,4.5a147.44,147.44,0,0,1,11.459,11.4,133.812,133.812,0,0,1,9.921,12.76c1.315,2.111,2.671,4.05,3.714,6q.816,1.44,1.577,2.783.684,1.377,1.314,2.643c.407.848.836,1.635,1.164,2.416s.636,1.513.927,2.2.553,1.326.8,1.92l.568,1.654c.315.95.566,1.713.759,2.3a4.32,4.32,0,0,1,.224.813",
    transform: "translate(3.539 96.635)",
    fill: "#263238"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_192",
    "data-name": "Caminho 192",
    d: "M103.545,340.338c0,.1-1.6.1-4.157.241a74.4,74.4,0,0,0-19.618,3.727c-2.436.805-3.918,1.389-3.956,1.3a3.941,3.941,0,0,1,.988-.536c.65-.314,1.614-.718,2.822-1.177a59.17,59.17,0,0,1,19.749-3.751c1.291-.015,2.335.008,3.056.06a3.891,3.891,0,0,1,1.116.137",
    transform: "translate(21.251 95.342)",
    fill: "#263238"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_193",
    "data-name": "Caminho 193",
    d: "M108.111,381.272c-.187.1-1.676-4.193-5.417-8.171-3.692-4.025-7.86-5.827-7.748-6.006a9.2,9.2,0,0,1,2.675,1.183,23.633,23.633,0,0,1,9.509,10.239,9.272,9.272,0,0,1,.982,2.755",
    transform: "translate(26.613 102.897)",
    fill: "#263238"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_194",
    "data-name": "Caminho 194",
    d: "M80.893,302.82c.125.133-2.3,2.535-4.942,5.79s-4.523,6.1-4.68,6.006c-.138-.078,1.509-3.112,4.2-6.4s5.32-5.518,5.423-5.4",
    transform: "translate(19.976 84.881)",
    fill: "#263238"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_195",
    "data-name": "Caminho 195",
    d: "M72.585,292.094c.169-.028.705,2.3,1.2,5.194s.757,5.27.588,5.3-.705-2.3-1.2-5.194-.757-5.27-.588-5.3",
    transform: "translate(20.332 81.875)",
    fill: "#263238"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_196",
    "data-name": "Caminho 196",
    d: "M55.155,325.749c.152.079-1.574,3.709-3.852,8.106s-4.252,7.9-4.4,7.823,1.572-3.708,3.852-8.107,4.251-7.9,4.4-7.821",
    transform: "translate(13.144 91.309)",
    fill: "#263238"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_197",
    "data-name": "Caminho 197",
    d: "M41.9,314.323c.154-.077,1.616,2.549,3.265,5.864s2.864,6.065,2.71,6.14-1.616-2.548-3.266-5.864-2.863-6.064-2.709-6.14",
    transform: "translate(11.742 88.106)",
    fill: "#263238"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_198",
    "data-name": "Caminho 198",
    d: "M27.673,353.672c-.041.178-2.654-.33-5.911-.553-3.257-.239-5.915-.1-5.93-.287-.02-.159,2.657-.575,5.974-.333s5.911,1.019,5.868,1.173",
    transform: "translate(4.437 98.787)",
    fill: "#263238"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_199",
    "data-name": "Caminho 199",
    d: "M36.568,387.947l7.326,38.529a5.4,5.4,0,0,0,5.3,4.391H70.843a5.4,5.4,0,0,0,5.327-4.517l6.37-38.4Z",
    transform: "translate(10.25 108.743)",
    fill: "#263238"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_200",
    "data-name": "Caminho 200",
    d: "M38.948,400.469H80.339l2.2-12.523H36.568Z",
    transform: "translate(10.25 108.743)",
    fill: "#455a64"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_201",
    "data-name": "Caminho 201",
    d: "M38.427,397.727l.868,4.566H79.184l.634-4.566Z",
    transform: "translate(10.771 111.485)",
    fill: "#fafafa"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenImage);
export default __webpack_public_path__ + "static/media/tokenImage.abd0b77a7369d55e5f3123b3c2eb4cb6.svg";
export { ForwardRef as ReactComponent };